import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";

import Base from "../views/smart/Base";

const Routes = props => (
  <Switch>
    <Route
      path="/portal/smart/base"
      render={internalProps => (
        <Base {...internalProps} {...props} />
      )}
    />
    <Route render={() => <Redirect to="/portal/smart/base" />} />
  </Switch>
);

export default Routes;
